import api from "./api";

const updateCloudOrgStructureElement = (cloudOrgStructure) => {
  return api
    .patch("/cloudorgstructure", {
      ...cloudOrgStructure,
    })
    .then((response) => {
      return response.data;
    });
};


const getCloudOrgStructure = (search) => {
  return api
    .get("/cloudorgstructure", {
      params: {
        ...search,
      },
    })
    .then((response) => {
      return response.data;
    });
};

const getOpportunitiyLogs = (search) => {
  return api
    .get("/cloudorgstructure/log", {
      params: {
        ...search,
      },
    })
    .then((response) => {
      return response.data;
    });
};

/**
 * Look one element up by id, without putting the id in the URL path.
 *
 * `GET /api/v1/cloudorgstructure/{id}` cannot carry a flattened Resource id, because that id
 * IS the Azure resource path ("/subscriptions/<sub>/resourcegroups/<rg>/.../<name>"):
 *
 *  - Raw, the request becomes `/api/v1/cloudorgstructure//subscriptions/...`; gorilla/mux
 *    runs cleanPath on every request and answers 301 to the collapsed path, which has lost
 *    the id's leading slash.
 *  - Percent-encoded, Go decodes %2F back to "/" in r.URL.Path before grpc-gateway matches
 *    (runtime.NewServeMux defaults to UnescapingModeLegacy, which the kernel does not
 *    override), producing exactly the same 301.
 *
 * So the id travels in the query string instead, as the list endpoint's exact-match filter.
 * `[id]` is rewritten to `[_id]` server-side, and a value that does not start with "*", "-",
 * "!=" or a quote is an indexed equality rather than a regex -- so this is a single-document
 * lookup, not a scan. The "|" the server uses to append its own `[active]=true` term never
 * occurs in an Azure resource id, so the two terms cannot run together.
 *
 * The single row is unwrapped here so the thunk, the reducer and every consumer keep seeing
 * one element object.
 *
 * An empty page rejects rather than resolving: the endpoint this replaces answered a missing
 * id with NotFound, the thunks in turn surface that as an error message, and the fulfilled
 * reducer dereferences `payload.id`. Note that `[active]=true` is appended server-side, so a
 * soft-deleted element now reads as missing.
 */
const getCloudOrgStructureElement = (id) => {
  return api
    .get("/cloudorgstructure", {
      params: {
        filter: `[id]=${id}`,
        page: 0,
        page_size: 1,
      },
    })
    .then((response) => {
      const element = response.data?.list?.[0];

      if (!element) {
        throw new Error(`Cloud org structure element not found: ${id}`);
      }

      return element;
    });
};

const getCloudOrgStructureByType = ({search}) => {

  return api.get("/cloudorgstructurebytype/" + search.resourceType + "/" + search.wantedResource).then((response) => {
    return response.data;
  });
};

const createCloudOrgStructureElement = (CloudOrgStructureElement) => {
  return api.post("/cloudorgstructure", {
    ...CloudOrgStructureElement,
  });
};

const getCloudOrgStructureFilterValues = (search) => {

  return api.get("/cloudorgstructure/filtervalues",{
    params: {
      ...search
    }
  })
  .then((response) => {
    return response.data;
  });
};

const runCloudOrgStructure = () => {
  return api.get("/cloudorgstructure/run")
  .then((response) => {
    return response.data;
  });
};


const getCloudOrgStructureUi = () => {
  return api.get("/cloudorgstructure/ui")
  .then((response) => {
    return response.data;
  });
};

const getCloudOrgStructureFieldDescriptions = () => {
  return api.get("/cloudorgstructure/fielddescriptions")
  .then((response) => {
    return response.data;
  });
};

const CloudOrgStructureService = {
  getCloudOrgStructureElement,
  updateCloudOrgStructureElement,
  getCloudOrgStructure,
  getOpportunitiyLogs,
  getCloudOrgStructureFilterValues,
  runCloudOrgStructure,
  createCloudOrgStructureElement,
  getCloudOrgStructureByType,
  getCloudOrgStructureUi,
  getCloudOrgStructureFieldDescriptions,

};

export default CloudOrgStructureService;
